<template>
  <div>
    <div class="page-content">
      <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
        <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
          <div class="card">
            <div class="card-body">
              <!--begin::loading-data-->
              <div v-if="isLoading" class="d-flex align-items-center">
                <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                <strong>{{ $t('loadingTxt') }}...</strong>
              </div>
              <!--end::loading-data-->

              <form class="forms-sample" @submit.prevent="submitData" method="POST">
                <div class="d-flex justify-content-between align-items-baseline mb-2"></div>

                <div class="card">
                  <div class="card-header">
                    <h6 class="card-title mb-0 float-start" style="padding-left: 25px">FPPK PENERIMAAN</h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <!-- no_fppk -->
                        <div class="row mb-3">
                          <label for="no_fppk" class="col-sm-4 col-form-label">No Fppk</label>
                          <div class="col-sm-7">
                            <input type="text" class="form-control" id="no_fppk" placeholder="No Fppk" v-model="forms.no_fppk" readonly />
                            <div v-if="errors.no_fppk">
                              <div v-for="error in errors.no_fppk" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- maintenance_plant -->
                        <div class="row mb-3">
                          <label for="maintenance_plant" class="col-form-label col-sm-4">Maintenance Plant</label>
                          <div class="col-sm-7">
                            <v-select v-model="forms.maintenance_plant" :options="fetchMaintenancePlant"></v-select>
                            <div v-if="errors.maintenance_plant">
                              <div v-for="error in errors.maintenance_plant" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- status -->
                        <div class="row mb-3">
                          <label for="status" class="col-form-label col-sm-4">Status</label>
                          <div class="col-sm-7">
                            <v-select
                              v-model="forms.status"
                              :options="fetchStatus"
                              :disabled="forms.editFlag == '1' || forms.editFlag == '2'"></v-select>
                            <div v-if="errors.status">
                              <div v-for="error in errors.status" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- type_service -->
                        <div class="row mb-3">
                          <label for="type_service" class="col-form-label col-sm-4">Type Service</label>
                          <div class="col-sm-7">
                            <v-select
                              v-model="forms.type_service"
                              :options="fetchTypeService"
                              :disabled="forms.editFlag == '1' || forms.editFlag == '2'"></v-select>
                            <div v-if="errors.type_service">
                              <div v-for="error in errors.type_service" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- type_service2 -->
                        <div class="row mb-3">
                          <label for="type_service2" class="col-form-label col-sm-4">Type Service 2</label>
                          <div class="col-sm-7">
                            <v-select v-model="forms.type_service2" :options="fetchTypeService2" :disabled="forms.editFlag == '0'"></v-select>
                            <div v-if="errors.type_service2">
                              <div v-for="error in errors.type_service2" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- lokasi_unit -->
                        <div class="row mb-3">
                          <label for="lokasi_unit" class="col-form-label col-sm-4">Lokasi Unit</label>
                          <div class="col-sm-7">
                            <input type="text" v-model="forms.lokasi_unit" class="form-control" />
                            <div v-if="errors.lokasi_unit">
                              <div v-for="error in errors.lokasi_unit" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- nmk_driver -->
                        <div class="row mb-3">
                          <label for="nmk_driver" class="col-form-label col-sm-4">Driver NMK</label>
                          <div class="col-sm-7">
                            <multiselect
                              v-model="nmk_driver"
                              :options="fetchDriver"
                              :custom-label="customLabel"
                              :multiple="false"
                              :close-on-select="true"
                              :clear-on-select="true"
                              :preserve-search="true"
                              placeholder="Driver NMK"
                              label="driver_id"
                              track-by="driver_id"
                              @input="changeDriver"
                              @search-change="onSearchChangeDriver"></multiselect>

                            <div v-if="errors.nmk_driver">
                              <div v-for="error in errors.nmk_driver" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- driverName -->
                        <div class="row mb-3">
                          <label for="driverName" class="col-form-label col-sm-4">Driver Name</label>
                          <div class="col-sm-7">
                            <input type="text" readonly v-model="forms.driverName" class="form-control" />
                            <div v-if="errors.driverName">
                              <div v-for="error in errors.driverName" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- hp_driver -->
                        <div class="row mb-3">
                          <label for="hp_driver" class="col-form-label col-sm-4">Hp Driver</label>
                          <div class="col-sm-7">
                            <input type="text" readonly v-model="forms.hp_driver" class="form-control" />
                            <div v-if="errors.hp_driver">
                              <div v-for="error in errors.hp_driver" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- email_driver -->
                        <div class="row mb-3">
                          <label for="email_driver" class="col-form-label col-sm-4">Email Driver</label>
                          <div class="col-sm-7">
                            <input type="text" readonly v-model="forms.email_driver" class="form-control" />
                            <div v-if="errors.email_driver">
                              <div v-for="error in errors.email_driver" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- km_odo -->
                        <div class="row mb-3">
                          <label for="km_odo" class="col-sm-4 col-form-label">KM ODO</label>
                          <div class="col-sm-5">
                            <input type="text" class="form-control" id="km_odo" placeholder="KM ODO" v-model="forms.km_odo" />
                            <div v-if="errors.km_odo">
                              <div v-for="error in errors.km_odo" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- km_gps -->
                        <div class="row mb-3">
                          <label for="km_gps" class="col-sm-4 col-form-label">KM GPS</label>
                          <div class="col-sm-5">
                            <input type="text" class="form-control" id="km_gps" placeholder="KM GPS" v-model="km_gps" />
                            <div v-if="errors.km_gps">
                              <div v-for="error in errors.km_gps" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <button type="button" v-if="!loadingMGps" class="btn btn-primary" @click="getKm">GET KM GPS</button>
                            <span v-else>Waiting...</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <!-- tanggal_fppk -->
                        <div class="row mb-3">
                          <label for="tanggal_fppk" class="col-form-label col-sm-4">Tanggal FPPK</label>
                          <div class="col-sm-7">
                            <input type="text" class="form-control" id="tanggal_fppk" readonly placeholder="" v-model="forms.tanggal_fppk" />
                            <div v-if="errors.tanggal_fppk">
                              <div v-for="error in errors.tanggal_fppk" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- tgl_estimasi_tiba -->
                        <div class="row mb-3">
                          <label for="tgl_estimasi_tiba" class="col-form-label col-sm-4">Estimasi Tiba di Pool</label>
                          <div class="col-sm-7">
                            <input class="form-control" readonly v-model="forms.tgl_estimasi_tiba" />

                            <div v-if="errors.tgl_estimasi_tiba">
                              <div v-for="error in errors.tgl_estimasi_tiba" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- nopol -->
                        <div class="row mb-3">
                          <label for="nopol" class="col-form-label col-sm-4">Nopol</label>
                          <div class="col-sm-7">
                            <input type="text" class="form-control" id="nopol" readonly placeholder="" v-model="forms.nopol" />
                            <div v-if="errors.nopol">
                              <div v-for="error in errors.nopol" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- merk -->
                        <div class="row mb-3">
                          <label for="merk" class="col-form-label col-sm-4">Merk</label>
                          <div class="col-sm-7">
                            <input type="text" class="form-control" id="merk" readonly placeholder="" v-model="forms.merk" />
                            <div v-if="errors.merk">
                              <div v-for="error in errors.merk" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- jenis_unit -->
                        <div class="row mb-3">
                          <label for="jenis_unit" class="col-form-label col-sm-4">Jenis Unit</label>
                          <div class="col-sm-7">
                            <input type="text" class="form-control" id="jenis_unit" readonly placeholder="" v-model="forms.jenis_unit" />
                            <div v-if="errors.jenis_unit">
                              <div v-for="error in errors.jenis_unit" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- keluhan1 -->
                        <div class="row mb-3">
                          <label for="keluhan1" class="col-form-label col-sm-4">Keluhan 1</label>
                          <div class="col-sm-7">
                            <input type="text" readonly v-model="forms.keluhan1" class="form-control" />
                            <div v-if="errors.keluhan1">
                              <div v-for="error in errors.keluhan1" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="row mb-3">
                          <label for="defaultconfig" class="col-form-label col-sm-4">Analisa 1</label>
                          <div class="col-sm-7">
                            <textarea class="form-control" id="analisa2" v-model="forms.analisa1"></textarea>
                            <div v-if="errors.analisa1">
                              <div v-for="error in errors.analisa1" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- keluhan2 -->
                        <div class="row mb-3">
                          <label for="keluhan2" class="col-form-label col-sm-4">Keluhan 2</label>
                          <div class="col-sm-7">
                            <input type="text " readonly v-model="forms.keluhan2" class="form-control" />
                            <div v-if="errors.keluhan1">
                              <div v-for="error in errors.keluhan2" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="row mb-3">
                          <label for="defaultconfig" class="col-form-label col-sm-4">Analisa 2</label>
                          <div class="col-sm-7">
                            <textarea class="form-control" id="analisa2" v-model="forms.analisa2"></textarea>
                            <div v-if="errors.analisa2">
                              <div v-for="error in errors.analisa2" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- keluhan3 -->
                        <div class="row mb-3">
                          <label for="keluhan3" class="col-form-label col-sm-4">Keluhan 3</label>
                          <div class="col-sm-7">
                            <input type="text" v-model="forms.keluhan3" readonly class="form-control" />
                            <div v-if="errors.keluhan3">
                              <div v-for="error in errors.keluhan3" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="row mb-3">
                          <label for="defaultconfig" class="col-form-label col-sm-4">Analisa 3</label>
                          <div class="col-sm-7">
                            <textarea class="form-control" id="analisa3" v-model="forms.analisa3"></textarea>
                            <div v-if="errors.analisa3">
                              <div v-for="error in errors.analisa3" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- keluhan4 -->
                        <div class="row mb-3">
                          <label for="keluhan4" class="col-form-label col-sm-4">Keluhan 4</label>
                          <div class="col-sm-7">
                            <input type="text" v-model="forms.keluhan4" readonly class="form-control" />
                            <div v-if="errors.keluhan4">
                              <div v-for="error in errors.keluhan4" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="row mb-3">
                          <label for="defaultconfig" class="col-form-label col-sm-4">Analisa 4</label>
                          <div class="col-sm-7">
                            <textarea class="form-control" id="analisa4" v-model="forms.analisa4"></textarea>
                            <div v-if="errors.analisa4">
                              <div v-for="error in errors.analisa4" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- keluhan5 -->
                        <div class="row mb-3">
                          <label for="keluhan5" class="col-form-label col-sm-4">Keluhan 5</label>
                          <div class="col-sm-7">
                            <input type="text" readonly v-model="forms.keluhan5" class="form-control" />
                            <div v-if="errors.keluhan5">
                              <div v-for="error in errors.keluhan5" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="row mb-3">
                          <label for="defaultconfig" class="col-form-label col-sm-4">Analisa 5</label>
                          <div class="col-sm-7">
                            <textarea class="form-control" id="analisa5" v-model="forms.analisa5"></textarea>
                            <div v-if="errors.analisa5">
                              <div v-for="error in errors.analisa5" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- keluhan6 -->
                        <div class="row mb-3">
                          <label for="keluhan6" class="col-form-label col-sm-4">Keluhan 6</label>
                          <div class="col-sm-7">
                            <input type="text" readonly v-model="forms.keluhan6" class="form-control" />
                            <div v-if="errors.keluhan6">
                              <div v-for="error in errors.keluhan6" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- status_fppk_text -->
                        <div class="row mb-3">
                          <label for="status_fppk_text" class="col-sm-4 col-form-label">Status FPPK</label>
                          <div class="col-sm-7">
                            <input type="text" class="form-control" readonly id="status_fppk_text" v-model="status_fppk_text" />
                            <!-- <div v-if="errors.period_code">
                            <div v-for="error in errors.period_code" :key="error" class="alert alert-primary" role="alert">
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div> -->
                          </div>
                        </div>
                        <!-- route -->
                        <div class="row mb-3">
                          <label for="route" class="col-sm-4 col-form-label">Route</label>
                          <div class="col-sm-7">
                            <input type="text" class="form-control" id="route" placeholder="Route" v-model="forms.route" />
                            <div v-if="errors.route">
                              <div v-for="error in errors.route" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- <div class="row mb-3">
                          <label for="defaultconfig" class="col-form-label col-sm-4">Analisa 6</label>
                          <div class="col-sm-7">
                            <textarea class="form-control" id="analisa6" v-model="forms.analisa6"></textarea>
                            <div v-if="errors.analisa6">
                              <div v-for="error in errors.analisa6" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <br />

                <div class="card">
                  <div class="card-header">
                    <h6 class="card-title mb-0 float-start" style="padding-left: 25px">WO</h6>
                  </div>
                  <div class="card-body">
                    <!-- Details Activity -->
                    <div class="card-body mb-5">
                      <div class="row">
                        <div class="col-12 mb-3 d-flex align-items-center">
                          <button type="button" class="btn btn-primary" @click="tambahAktifitas">Tambah Aktifitas</button>

                          <!-- Pemberitahuan -->
                          <small class="text-danger ml-3" style="font-style: italic; margin-left: 20px">
                            Data aktifitas diperbarui ke dalam database setelah klik submit form.
                          </small>
                        </div>

                        <div class="col-12">
                          <vue-good-table
                            title="list-activity"
                            :totalRows="totalRecords"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :rows="savedActivity"
                            :column-filter="true"
                            :columns="activityColumns">
                            <template slot="table-row" slot-scope="props">
                              <span v-if="props.column.field === 'actions'">
                                <button type="button" class="btn btn-sm btn-danger" @click="hapusAktifitas(props.index, props.row)">Hapus</button>
                                <button
                                  :ref="'editButton' + props.index"
                                  style="margin-left: 10px"
                                  type="button"
                                  v-if="isEditingIndex !== props.index"
                                  class="btn btn-sm btn-secondary"
                                  @click="editAktifitas(props.index, props.row)">
                                  Edit
                                </button>
                                <button
                                  style="margin-left: 10px"
                                  type="button"
                                  v-if="isEditingIndex === props.index"
                                  class="btn btn-sm btn-success"
                                  @click="simpanAktifitas(props.index, props.row)">
                                  Simpan
                                </button>
                              </span>

                              <span v-else-if="props.column.field === 'activity'">
                                <div v-if="isEditingIndex === props.index" ref="activityDropdown" style="position: relative">
                                  <!-- Input pencarian untuk mencari aktivitas -->
                                  <input
                                    type="text"
                                    v-model="searchQuery"
                                    @input="onSearchActivity"
                                    @keydown.down="navigateDropdown('down')"
                                    @keydown.up="navigateDropdown('up')"
                                    @keydown.enter="selectWithEnter"
                                    @focus="
                                      () => {
                                        hasSelectedActivity = false;
                                        loadSearchActivity();
                                        isActivityInputFocused = true;
                                      }
                                    "
                                    @blur="() => (isActivityInputFocused = false)"
                                    class="form-control form-control-sm mb-1"
                                    placeholder="Cari Aktifitas" />

                                  <!-- Input readonly untuk menampilkan value -->
                                  <input type="text" :value="props.row.activity" class="form-control form-control-sm" readonly />

                                  <!-- List Dropdown -->
                                  <ul v-if="filteredActivities.length > 0" class="dropdown-list">
                                    <!-- Spinner loading -->
                                    <li v-if="isSearchingActivity" class="dropdown-spinner">
                                      <div class="spinner"></div>
                                    </li>

                                    <!-- List hasil pencarian -->
                                    <li
                                      v-for="(activity, index) in filteredActivities"
                                      :key="activity.master_activity_id"
                                      @mousedown="isSelectingFromDropdown = true"
                                      @click="selectActivity(activity, props.index)"
                                      :class="{ active: selectedItemIndex === index }"
                                      class="dropdown-item"
                                      :ref="'dropdownItem-' + index">
                                      {{ activity.description }}
                                    </li>
                                  </ul>
                                  <tr class="no-line-number-row">
                                    <td style="height: 200px; border: none; padding: 0"></td>
                                  </tr>

                                  <!-- Pesan 'Data tidak ditemukan' -->
                                  <div
                                    v-if="searchQuery.length > 0 && filteredActivities.length === 0 && !isSearchingActivity && !hasSelectedActivity"
                                    class="no-results">
                                    <span>Data tidak ditemukan</span>
                                  </div>
                                </div>

                                <!-- Tampilkan nilai jika tidak dalam mode edit -->
                                <span v-else>
                                  {{ props.formattedRow.activity }}
                                </span>
                              </span>

                              <span v-else-if="props.column.field === 'duration'">
                                <div v-if="isEditingIndex === props.index">
                                  <input
                                    ref="durationInput"
                                    placeholder="00:00:00"
                                    :readonly="props.row.activity?.toLowerCase() !== 'waiting part'"
                                    :value="props.row.duration"
                                    @input="formatDurationInput($event, props.index)"
                                    class="form-control form-control-sm"
                                    :class="{ 'is-invalid': durationErrors[props.index] }" />
                                  <small v-if="durationErrors[props.index]" class="text-danger">{{ durationErrors[props.index] }}</small>
                                </div>

                                <span v-else>{{ props.formattedRow.duration }}</span>
                              </span>

                              <span v-else-if="props.column.field === 'category_problem'">
                                <input
                                  ref="categoryProblemInput"
                                  v-if="isEditingIndex === props.index"
                                  :value="props.row[props.column.field]"
                                  class="form-control form-control-sm"
                                  readonly />
                                <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                              </span>

                              <span v-else>
                                <input
                                  ref="remarksInput"
                                  v-if="isEditingIndex === props.index"
                                  v-model="props.row[props.column.field]"
                                  class="form-control form-control-sm"
                                  @input="updateActivity(props.index, props.row, props.column.field)" />
                                <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                              </span>
                            </template>
                          </vue-good-table>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <!-- Edit Status -->
                        <div class="row mb-3">
                          <label for="status_fppk" class="col-form-label col-sm-5">Edit Status</label>
                          <div class="col-sm-7">
                            <v-select
                              v-model="forms.status_fppk"
                              :disabled="permision_role.method_custom1 != 1"
                              :options="fetchStatusFppk"
                              @input="changeServiceRemark"></v-select>
                            <div v-if="errors.status_fppk">
                              <div v-for="error in errors.status_fppk" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- mulai_service -->
                        <div class="row mb-3">
                          <label for="mulai_service" class="col-form-label col-sm-5">Mulai Service</label>
                          <div class="col-sm-7">
                            <date-range-picker
                              style="width: 100%"
                              :locale-data="locale"
                              v-model="mulai_service"
                              :opens="opens"
                              :singleDatePicker="true"
                              :timePicker24Hour="true"
                              @change="updateEstimasiRFU"
                              :timePicker="true"></date-range-picker>

                            <div v-if="errors.mulai_service">
                              <div v-for="error in errors.mulai_service" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- estimasi_selesai -->
                        <div class="row mb-3">
                          <label for="estimasi_selesai" class="col-form-label col-sm-5">Estimasi Selesai Service</label>
                          <div class="col-sm-7">
                            <date-range-picker
                              :disabled="true"
                              style="width: 100%; background-color: #e9ecef; cursor: not-allowed; opacity: 0.5"
                              :locale-data="locale"
                              v-model="estimasi_selesai"
                              :opens="opens"
                              :singleDatePicker="true"
                              :timePicker24Hour="true"
                              :timePicker="true"></date-range-picker>

                            <div v-if="errors.estimasi_selesai">
                              <div v-for="error in errors.estimasi_selesai" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- selesai_service -->
                        <div class="row mb-3" v-if="fieldSelesaiService">
                          <label for="selesai_service" class="col-form-label col-sm-5">Aktual Selesai Service</label>
                          <div class="col-sm-7">
                            <date-range-picker
                              style="width: 100%"
                              :locale-data="locale"
                              v-model="selesai_service"
                              :opens="opens"
                              :singleDatePicker="true"
                              :timePicker24Hour="true"
                              :timePicker="true"></date-range-picker>

                            <div v-if="errors.selesai_service">
                              <div v-for="error in errors.selesai_service" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <!-- jmlEstimasi -->
                        <div class="row mb-3">
                          <h5>Estimasi Service : {{ jmlEstimasi }}</h5>
                        </div>
                        <!-- grand_total_sla -->
                        <div class="row mb-3">
                          <label for="grand_total_sla" class="col-sm-4 col-form-label">Grand Total SLA</label>
                          <div class="col-sm">
                            <input type="text" class="form-control" readonly id="grand_total_sla" v-model="grand_total_sla" />
                            <!-- <div v-if="errors.period_code">
                            <div v-for="error in errors.period_code" :key="error" class="alert alert-primary" role="alert">
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div> -->
                          </div>
                        </div>
                        <!-- estimasi_rfu -->
                        <div class="row mb-3">
                          <label for="estimasi_rfu" class="col-sm-4 col-form-label">Estimasi RFU</label>
                          <div class="col-sm">
                            <input type="text" class="form-control" readonly id="estimasi_rfu" v-model="estimasi_rfu" />
                            <!-- <div v-if="errors.period_code">
                            <div v-for="error in errors.period_code" :key="error" class="alert alert-primary" role="alert">
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div> -->
                          </div>
                        </div>
                        <!-- service_remark -->
                        <div class="row mb-3" v-if="service_remarks_">
                          <label for="service_remark" class="col-sm-4 col-form-label">Service Remarks</label>
                          <div class="col-sm">
                            <textarea class="form-control" v-model="forms.service_remark" rows="3"></textarea>
                            <div v-if="errors.service_remark">
                              <div v-for="error in errors.service_remark" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <button class="btn btn-warning text-black fw-bolder btn-icon-text" @click="backForm" type="button">
                    <i class="link-icon" data-feather="arrow-left"></i>
                    {{ $t('backMess') }}
                  </button>

                  &nbsp;&nbsp;&nbsp;
                  <button v-if="!isLoading" class="btn btn-primary float-end btn-sm" type="button" @click="submitData">
                    <i class="link-icon" data-feather="save"></i>
                    {{ $t('submitFormTxt') }}
                  </button>

                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                    <strong>{{ $t('loadingTxt') }}...</strong>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!--end::card-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
import multiselect from 'vue-multiselect';

export default {
  name: 'GerbangTolAdd',
  props: {},
  components: {
    DateRangePicker,
    multiselect: multiselect,
  },
  data() {
    return {
      fieldSelesaiService: true,
      jmlEstimasi: 0,
      fppk_id: '',
      showModalEskalasiFppk: false,
      dataShowEskalasi: '',
      service_remarks_: false,
      locale: {
        format: 'dd mmm yyyy H:MM:ss',
      },
      status_fppk_text: '',
      fetchStatusFppk: ['On Progress', 'Selesai Service'],
      fetchMaintenancePlant: [],
      fetchTypeService: [],
      fetchTypeService2: [],
      km_gps: '',
      grand_total_sla: '00:00:00',
      estimasi_rfu: '00:00:00',
      loadingMGps: false,
      truck: '',
      nmk_driver: '',
      fetchTruck: [],
      fppkDate: {
        startDate: null,
        endDate: null,
      },
      tgl_estimasi_tiba: {
        startDate: null,
        endDate: null,
      },
      mulai_service: {
        startDate: null,
        endDate: null,
      },
      estimasi_selesai: {
        startDate: null,
        endDate: null,
      },
      selesai_service: {
        startDate: null,
        endDate: null,
      },

      fetchStatus: [],
      fetchRoute: [],
      fetchMerk: [],
      fetchJenisUnit: [],
      fetchDriver: [],

      opens: 'center',
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: 'up right',
      closeBtn: true,
      errors: [],
      userData: '',
      companyCode: '',
      fetchCompany: [],
      fetchCompanyNotLinc: [],
      forms: { pcs_qty: 1 },
      company: [],
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        per_page: 10,
      },
      activityColumns: [
        {
          label: 'Action',
          field: 'actions',
          width: '160px',
          sortable: false,
        },
        {
          label: 'Activity',
          field: 'activity',
          width: '300px',
          sortable: false,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Category',
          field: 'category_problem',
          sortable: false,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Duration',
          field: 'duration',
          width: '110px',
          sortable: false,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Remarks',
          field: 'remarks',
          sortable: false,
          filterOptions: {
            enabled: true,
          },
        },
      ],
      activityRows: [],
      totalRecords: 0,
      isEditingIndex: null,
      newActivity: {
        no_fppk: '',
        job_no: '',
        activity: '',
        category_problem: '',
        duration: '',
        remarks: '',
      },
      savedActivity: [],
      fetchActivityOptions: [], // list activity yang akan muncul di dropdown
      isSearchingActivity: false,
      selectedActivity: null,
      activityOptions: [],
      searchQuery: '', // Untuk menyimpan input pencarian
      filteredActivities: [], // Untuk menyimpan hasil filter aktivitas
      selectedItemIndex: -1,
      hasSelectedActivity: false,
      durationErrors: {},
      isActivityInputFocused: false,
      isSelectingFromDropdown: false,
      justClickedEdit: false,
      justAddedActivity: false,
    };
  },
  watch: {
    searchQuery(newQuery) {
      if (newQuery === '') {
        this.filteredActivities = [];
        this.selectedItemIndex = -1;
        this.hasSelectedActivity = false;
      }
    },
    'mulai_service.startDate': function () {
      this.updateEstimasiRFU();
      this.updateEstimasiSelesai();
    },
    grand_total_sla: 'updateEstimasiRFU',
    estimasi_rfu: 'updateEstimasiSelesai',
  },
  methods: {
    updateEstimasiSelesai() {
      if (!this.mulai_service.startDate || !this.grand_total_sla) return;

      const mulaiDate = new Date(this.mulai_service.startDate);
      const [hours, minutes, seconds] = this.grand_total_sla.split(':').map(Number);
      let totalMilliseconds = (hours * 3600 + minutes * 60 + seconds) * 1000;

      const istirahatStartHour = 12;
      const istirahatEndHour = 13;

      let adjustedStart = new Date(mulaiDate);

      // Jika mulai di dalam jam istirahat, geser ke jam 13:00
      if (adjustedStart.getHours() >= 12 && adjustedStart.getHours() < 13) {
        adjustedStart.setHours(13, 0, 0, 0);
      }

      let estimasiSelesai = new Date(adjustedStart.getTime() + totalMilliseconds);

      // Hitung berapa hari di antara waktu mulai & estimasi selesai
      let tempDate = new Date(adjustedStart);
      while (tempDate < estimasiSelesai) {
        const istirahatStart = new Date(tempDate);
        istirahatStart.setHours(istirahatStartHour, 0, 0, 0);
        const istirahatEnd = new Date(tempDate);
        istirahatEnd.setHours(istirahatEndHour, 0, 0, 0);

        // Jika estimasi melintasi jam istirahat hari ini, tambahkan 1 jam
        if (adjustedStart < istirahatStart && estimasiSelesai > istirahatStart) {
          totalMilliseconds += 60 * 60 * 1000;
          estimasiSelesai = new Date(adjustedStart.getTime() + totalMilliseconds);
        }

        // Lanjut ke hari berikutnya
        tempDate.setDate(tempDate.getDate() + 1);
        tempDate.setHours(0, 0, 0, 0); // Reset jam
      }

      this.estimasi_selesai = {
        startDate: estimasiSelesai,
        endDate: estimasiSelesai,
      };
    },

    updateEstimasiRFU() {
      if (!this.mulai_service.startDate || !this.grand_total_sla || this.grand_total_sla === '00:00:00') {
        this.estimasi_rfu = '00:00:00';
        return;
      }

      // Ambil objek Date dari startDate
      const mulaiDate = new Date(this.mulai_service.startDate);

      // Pecah grand_total_sla menjadi jam, menit, detik
      const [slaHours, slaMinutes, slaSeconds] = this.grand_total_sla.split(':').map(Number);

      // Log nilai input
      console.log('Mulai Date:', mulaiDate);
      console.log('SLA Hours:', slaHours, 'SLA Minutes:', slaMinutes, 'SLA Seconds:', slaSeconds);

      // Ambil jam, menit, detik dari startDate
      let totalHours = mulaiDate.getHours();
      let totalMinutes = mulaiDate.getMinutes();
      let totalSeconds = mulaiDate.getSeconds();

      // Tambahkan SLA
      totalHours += slaHours;
      totalMinutes += slaMinutes;
      totalSeconds += slaSeconds;

      // Jika detik lebih dari 60, tambahkan menit
      if (totalSeconds >= 60) {
        const extraMinutes = Math.floor(totalSeconds / 60);
        totalMinutes += extraMinutes;
        totalSeconds = totalSeconds % 60;
      }

      // Jika menit lebih dari 60, tambahkan jam
      if (totalMinutes >= 60) {
        const extraHours = Math.floor(totalMinutes / 60);
        totalHours += extraHours;
        totalMinutes = totalMinutes % 60;
      }

      // Format jam, menit, dan detik menjadi HH:MM:SS
      const formatted = `${String(totalHours).padStart(2, '0')}:${String(totalMinutes).padStart(2, '0')}:${String(totalSeconds).padStart(2, '0')}`;

      // Update estimasi_rfu dengan hasil perhitungan
      this.estimasi_rfu = formatted;

      // Log hasil estimasi_rfu
      console.log('Estimasi RFU:', this.estimasi_rfu);
    },
    // Fungsi untuk menghitung total SLA
    calculateGrandTotalSla() {
      let totalSlaInSeconds = 0; // Menyimpan total durasi dalam detik

      // Loop melalui setiap activity untuk akumulasi duration
      this.savedActivity.forEach((activity) => {
        if (activity.duration) {
          // Mengubah durasi format HH:MM:SS menjadi detik
          const durationInSeconds = this.convertDurationToSeconds(activity.duration);
          totalSlaInSeconds += durationInSeconds;
        }
      });

      // Mengupdate grand_total_sla dengan total durasi dalam format HH:MM:SS
      this.grand_total_sla = this.convertSecondsToDuration(totalSlaInSeconds);
    },

    // Fungsi untuk mengonversi durasi dari format HH:MM:SS ke detik
    convertDurationToSeconds(duration) {
      const [hours, minutes, seconds] = duration.split(':').map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    },

    // Fungsi untuk mengonversi detik ke format HH:MM:SS
    convertSecondsToDuration(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;

      // Menyusun kembali menjadi format HH:MM:SS, pastikan semuanya 2 digit
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    },

    scrollToActiveItem() {
      this.$nextTick(() => {
        const refName = 'dropdownItem-' + this.selectedItemIndex;
        const el = this.$refs[refName];
        if (el && el[0]) {
          el[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    },

    async onSearchActivity() {
      // Jika query kosong, langsung hapus hasil filter
      if (!this.searchQuery) {
        this.filteredActivities = [];
        return;
      }

      if (this.searchQuery.length > 0) {
        this.isSearchingActivity = true; // Menandakan pencarian sedang berlangsung
        const baseURI = `${this.$settings.endPointFppk}v1/master-activity-fppk?limit=999999999&description=${this.searchQuery}`;
        try {
          const response = await this.$http.get(baseURI);
          this.filteredActivities = response.data.datas.data; // Menyimpan hasil pencarian
        } catch (error) {
          console.error(error);
        } finally {
          this.isSearchingActivity = false; // Matikan status loading setelah pencarian selesai
        }
      } else {
        this.filteredActivities = []; // Kosongkan hasil pencarian jika query terlalu pendek
      }
    },

    selectActivity(activity, index) {
      const updated = this.savedActivity[index];
      if (updated && activity) {
        const cloned = JSON.parse(JSON.stringify(activity)); // deep clone

        // Memperbarui data yang sama seperti di selectWithEnter
        updated.activity = cloned.description;
        updated.duration = cloned.target_leadtime;
        updated.category_problem = cloned.category_problem;
        updated.job_no = cloned.job_no;
        updated.master_activity_id = cloned.master_activity_id; // pastikan ID tetap ikut
        updated.remarks = ''; // reset remarks saat memilih baru (opsional)

        // Setelah update, pastikan perhitungan total tetap dilakukan
      }

      this.searchQuery = '';
      this.filteredActivities = [];
      this.isSearchingActivity = false;
      this.selectedItemIndex = -1;
      this.hasSelectedActivity = true;
      this.calculateGrandTotalSla();
    },

    // Menangani pemilihan dengan Enter
    selectWithEnter(event) {
      if (this.selectedItemIndex !== -1) {
        const selectedActivity = this.filteredActivities[this.selectedItemIndex];

        // Memanggil selectActivity, ini akan memastikan fungsi select berjalan konsisten
        this.selectActivity(selectedActivity, this.isEditingIndex);

        event.preventDefault(); // Mencegah form submit atau aksi lainnya saat tekan Enter
        this.hasSelectedActivity = true;
        this.searchQuery = '';
        this.calculateGrandTotalSla();
      }
    },

    updateActivity(index, row, field) {
      const updatedActivity = this.savedActivity[index];
      if (updatedActivity) {
        updatedActivity[field] = row[field]; // Update specific field
        // Jika diperlukan, Anda bisa melakukan validasi atau proses lainnya
      }
    },

    // Menangani navigasi dropdown dengan keyboard
    navigateDropdown(direction) {
      if (direction === 'down' && this.selectedItemIndex < this.filteredActivities.length - 1) {
        this.selectedItemIndex++;
        this.scrollToActiveItem();
      } else if (direction === 'up' && this.selectedItemIndex > 0) {
        this.selectedItemIndex--;
        this.scrollToActiveItem();
      }
    },

    onSelectActivityDropdown(item, index) {
      const updated = this.savedActivity[index];
      if (updated && item) {
        const cloned = JSON.parse(JSON.stringify(item)); // deep clone

        updated.activity = cloned.description;
        updated.duration = cloned.target_leadtime;
        updated.category_problem = cloned.category_problem;
        updated.job_no = cloned.job_no;
        updated.master_activity_id = cloned.master_activity_id;
        updated.remarks = ''; // reset remarks juga di sini jika perlu
      }
      this.selectedItemIndex = -1;
    },

    asyncSearchActivity(searchQuery) {
      this.isSearchingActivity = true;
      const baseURI = `${this.$settings.endPointFppk}v1/master-activity-fppk?limit=999999999&description=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.fetchActivityOptions = response.data.datas.data; // sort berdasarkan description

          console.log('asyncSearchActivity:', JSON.stringify(this.fetchActivityOptions, null, 2));
        })
        .finally(() => {
          this.isSearchingActivity = false;
        });
    },

    loadSearchActivity() {
      this.isSearchingActivity = true;
      const baseURI = this.$settings.endPointFppk + `v1/master-activity-fppk?limit=999999999`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.fetchActivityOptions = response.data.datas.data; // urutkan A-Z berdasarkan description
          if (!this.searchQuery) {
            this.filteredActivities = this.fetchActivityOptions;
          }

          console.log('fetchActivityOptions:', JSON.stringify(this.fetchActivityOptions, null, 2));
        })
        .finally(() => {
          this.isSearchingActivity = false;
        });
    },

    // Fungsi untuk format input duration
    formatDurationInput(event, index) {
      let val = event.target.value;

      // Hanya ambil angka
      let digitsOnly = val.replace(/\D/g, '').slice(0, 6); // Maksimal 6 digit angka (HHMMSS)

      // Format otomatis ke HH:MM:SS
      let formatted = '';
      if (digitsOnly.length <= 2) {
        formatted = digitsOnly;
      } else if (digitsOnly.length <= 4) {
        formatted = digitsOnly.slice(0, 2) + ':' + digitsOnly.slice(2);
      } else {
        formatted = digitsOnly.slice(0, 2) + ':' + digitsOnly.slice(2, 4) + ':' + digitsOnly.slice(4, 6);
      }

      // Potong jika melebihi 8 karakter
      formatted = formatted.slice(0, 8);

      // Set ke v-model dan juga ke input field (agar fix tampilan)
      this.savedActivity[index].duration = formatted;
      event.target.value = formatted;

      // Validasi hanya kalau ada isinya
      if (formatted) {
        const regex = /^\d{1,3}:[0-5]\d:[0-5]\d$/;
        this.durationErrors[index] = regex.test(formatted) ? '' : 'Format harus HH:MM:SS dan valid (contoh: 25:30:00)';
      } else {
        // Kalau kosong, tidak perlu tampilkan error
        this.durationErrors[index] = '';
      }

      // Setelah memperbarui input, hitung ulang grand_total_sla
      this.calculateGrandTotalSla();
    },

    // Validasi durasi
    validateDuration(index, value) {
      if (!this.isValidDurationFormat(value)) {
        this.$set(this.durationErrors, index, true);
      } else {
        this.$delete(this.durationErrors, index);
      }
    },

    isValidDurationFormat(duration) {
      const pattern = /^\d{1,3}:[0-5]\d:[0-5]\d$/;
      return pattern.test(duration);
    },

    tambahAktifitas() {
      const newActivity = {
        job_no: '',
        activity: '',
        category_problem: '',
        duration: '',
        remarks: '',
        isNew: true,
      };
      this.savedActivity.push(newActivity);
      this.isEditingIndex = this.savedActivity.length - 1;

      this.justAddedActivity = true;
      setTimeout(() => {
        this.justAddedActivity = false;
      }, 200); // mirip seperti justClickedEdit
    },

    hapusAktifitas(index) {
      this.savedActivity.splice(index, 1);

      // Reset index edit jika baris yang dihapus adalah yang sedang di-edit
      if (this.isEditingIndex === index) {
        this.isEditingIndex = null;
      } else if (this.isEditingIndex > index) {
        this.isEditingIndex -= 1; // geser karena array berubah
      }

      this.calculateGrandTotalSla();
    },

    async editAktifitas(index, row) {
      if (this.isEditingIndex !== null) return;

      console.log('Edit Data:', row);

      this.justClickedEdit = true; // ← Tambahkan ini
      this.isEditingIndex = index;

      // Reset pencarian saat memulai edit
      this.searchQuery = '';
      this.filteredActivities = [];

      // Reset flag setelah sekejap, supaya tidak ganggu klik luar berikutnya
      setTimeout(() => {
        this.justClickedEdit = false;
      }, 200); // cukup 200ms
    },

    simpanAktifitas(index, row) {
      console.log('Save Data:', row);

      this.validateDuration(index, row.duration);
      if (this.durationErrors[index]) {
        return; // blok simpan jika format salah
      }

      // Update langsung berdasarkan index
      this.$set(this.savedActivity, index, {
        ...this.savedActivity[index],
        ...row,
      });

      // Panggil calculateGrandTotalSla untuk memperbarui grand_total_sla
      this.calculateGrandTotalSla();

      // Reset mode editing
      this.isEditingIndex = null;
    },

    handleClickOutside(event) {
      const dropdown = this.$refs.activityDropdown;

      // Tambahan: cegah simpan kalau baru saja klik tombol edit atau tambah
      if (this.justClickedEdit || this.justAddedActivity) return;

      const isClickOutside = !(
        (
          this.$refs.durationInput?.contains(event.target) ||
          this.$refs.categoryProblemInput?.contains(event.target) ||
          this.$refs.remarksInput?.contains(event.target)
        ) // Menambahkan input remarks disini
      );

      if (dropdown && !dropdown.contains(event.target) && isClickOutside) {
        this.filteredActivities = [];

        setTimeout(() => {
          if (!this.isActivityInputFocused && !this.isSelectingFromDropdown && this.isEditingIndex !== null) {
            const index = this.isEditingIndex;
            const row = this.savedActivity[index];
            this.simpanAktifitas(index, row);
          }

          this.isSelectingFromDropdown = false;
        }, 100);
      }
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      var params = this.$onBehind(this.$route.params.id);
      this.loadDataDetailActivity(params);
    },

    onPerPageChange(params) {
      this.updateParams({
        per_page: params.currentPerPage,
        page: 1, // <-- reset page ke 1
      });
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    loadDataDetailActivity(id) {
      const baseURI = this.$settings.endPointFppk + 'v1/penerimaan-fppk/detail-activity/' + id;
      var columnFilters = this.serverParams.columnFilters;
      var activity_no_fppk = encodeURIComponent(columnFilters['no_fppk'] || '');
      var activity_job_no = encodeURIComponent(columnFilters['job_no'] || '');
      var activity_activity = encodeURIComponent(columnFilters['activity'] || '');
      var activity_category_problem = encodeURIComponent(columnFilters['category_problem'] || '');
      var activity_duration = encodeURIComponent(columnFilters['duration'] || '');
      var activity_remarks = encodeURIComponent(columnFilters['remarks'] || '');
      this.$http
        .post(
          baseURI +
            `?limit=${this.serverParams.per_page === -1 ? 999999 : this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${
              this.serverParams.sort.field
            }&sort_type=${
              this.serverParams.sort.type
            }&no_fppk=${activity_no_fppk}&job_no=${activity_job_no}&activity=${activity_activity}&category_problem=${activity_category_problem}&duration=${activity_duration}&remarks=${activity_remarks}`
        )
        .then((response) => {
          this.activityRows = response.data.datas.data;
          this.savedActivity = JSON.parse(JSON.stringify(this.activityRows)); // Simpan salinan data
          this.totalRecords = response.data.datas.total;
          this.loading();
        });
    },

    submitData() {
      this.forms.tanggal_fppk = moment(this.fppkDate.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.forms.tgl_estimasi_tiba = moment(this.tgl_estimasi_tiba.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.forms.tgl_mulai_service = moment(this.mulai_service.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.forms.tanggal_estimasi_selesai = moment(this.estimasi_selesai.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.forms.tgl_selesai_service = moment(this.selesai_service.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.forms.nopol = this.truck.vehicle_no;
      this.forms.nmk_driver = this.nmk_driver.driver_id;
      this.forms.km_gps = this.km_gps;
      delete this.forms.detail_activity;
      this.forms.activity = this.savedActivity;
      this.forms.grand_total_sla = this.grand_total_sla ?? '00:00:00';
      this.forms.estimasi_rfu = this.estimasi_rfu ?? '00:00:00';
      console.log('forms as string:', JSON.stringify(this.forms, null, 2));
      //return;

      this.fade(true);
      const baseURI = this.$settings.endPointFppk + 'v1/penerimaan-fppk/update/' + this.forms.fppk_id;
      this.$http
        .patch(baseURI, this.forms)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.errors = [];
            var keluhanArray = [
              this.forms.keluhan1,
              this.forms.keluhan2,
              this.forms.keluhan3,
              this.forms.keluhan4,
              this.forms.keluhan5,
              this.forms.keluhan6,
            ].filter((keluhan) => keluhan !== undefined && keluhan !== null);

            var analisaArray = [
              this.forms.analisa1,
              this.forms.analisa2,
              this.forms.analisa3,
              this.forms.analisa4,
              this.forms.analisa5,
              this.forms.analisa6,
            ].filter((keluhan) => keluhan !== undefined && keluhan !== null);

            if (this.forms.editFlag == 0) {
              this.forms.status_fppk = 'Mulai Service';

              var dataSendCT = {
                vehicle_no: this.forms.nopol,
                status_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                master_status_id: 6,
                reference: this.forms.no_fppk,
                status_type: this.forms.status_fppk,
                estimation_date: this.forms.tgl_estimasi_tiba,
                fppk_keluhan: keluhanArray.join(';'),
                fppk_analisa: analisaArray.join(';'),
              };

              this.submitToCt(dataSendCT);
            }

            if (this.forms.status_fppk == 'Selesai Service') {
              var dataSendCT2 = {
                vehicle_no: this.forms.nopol,
                status_time: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                master_status_id: 5,
                reference: this.forms.no_fppk,
                status_type: this.forms.status_fppk,
                estimation_date: this.forms.tgl_estimasi_tiba,
                fppk_keluhan: keluhanArray.join(';'),
                fppk_analisa: analisaArray.join(';'),
              };
              this.submitToCt(dataSendCT2);
            }

            var params = this.$onRandom(this.forms.fppk_id);
            window.location.href = '/fppk-penerimaan/detail/' + params + '?status=200&msg=Successfully';
            this.success('Berhasil');
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              if (this.errors.message) {
                this.error(this.errors.message);
              } else {
                this.resultError(error.response.data.errors);
              }
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push('/page-not-found');
            }
          }
        });
    },

    loadData(id) {
      const baseURI = this.$settings.endPointFppk + 'v1/penerimaan-fppk/detail/' + id;
      return this.$http.get(baseURI).then((response) => {
        //console.log(response);
        this.forms = response.data.datas;

        this.fppkDate = {
          startDate: this.forms.tanggal_fppk,
          endDate: this.forms.tanggal_fppk,
        };

        this.tgl_estimasi_tiba = {
          startDate: this.forms.tgl_estimasi_tiba,
          endDate: this.forms.tgl_estimasi_tiba,
        };

        this.estimasi_selesai = {
          startDate: this.forms.tanggal_estimasi_selesai,
          endDate: this.forms.tanggal_estimasi_selesai,
        };

        this.selesai_service = {
          startDate: this.forms.tgl_selesai_service,
          endDate: this.forms.tgl_selesai_service,
        };

        this.mulai_service = {
          startDate: this.forms.tgl_mulai_service,
          endDate: this.forms.tgl_mulai_service,
        };

        this.jmlEstimasi = this.forms.editFlag + 1;

        this.nmk_driver = {
          driver_id: this.forms.nmk_driver,
          driver_name: this.forms.driverName,
        };

        this.truck = {
          vehicle_no: this.forms.nopol,
        };

        this.km_gps = this.forms.km_gps;
        this.grand_total_sla = this.forms.grand_total_sla ?? '00:00:00';
        this.estimasi_rfu = this.forms.estimasi_rfu ?? '00:00:00';

        this.status_fppk_text = this.forms.status_fppk;

        if (this.forms.status_fppk == 'Selesai Service') {
          this.service_remarks_ = true;
          this.fieldSelesaiService = true;
        } else {
          this.fieldSelesaiService = false;
          this.service_remarks_ = false;
        }

        if (this.forms.status_fppk != 'Selesai Service') {
          this.forms.status_fppk = 'On Progress';
        }
        // this.form={ name: 'asep', usernmae:res.username };
      });
    },

    resetForm() {
      this.forms.period_name = '';
      this.forms.price_gap = '';
      this.forms.price = '';
      this.forms.period_code = '';
      this.fppkDate = {
        startDate: null,
        endDate: null,
      };
      this.expiredDate = {
        startDate: null,
        endDate: null,
      };
    },

    loadCompany() {
      const baseURI = this.$settings.endPoint + 'company?limit=10';

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },

    loadCompanyNotLinc() {
      const baseURI = this.$settings.endPoint + `company/select`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },

    loadDriver() {
      const baseURI = this.$settings.endPointCt + `master-driver/select`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchDriver = response.data.datas.data;
      });
    },

    onSearchChangeDriver(ev) {
      const baseURI = this.$settings.endPointCt + `master-driver/select?driver_name=` + ev;
      return this.$http.get(baseURI).then((response) => {
        this.fetchDriver = response.data.datas.data;
      });
    },

    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + 'company?code=' + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },

    asyncSearchCompanyNotLinc(ev) {
      const baseURI = this.$settings.endPoint + 'company/select/code=' + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },

    changeNopol(ev) {
      this.forms.merk = ev.truck_brand;
      this.forms.jenis_unit = ev.type_truck;
      // console.log(ev);
    },

    changeDriver(ev) {
      this.forms.driverName = ev.driver_name;
      this.forms.hp_driver = ev.hp1;
      // console.log(ev);
    },

    loadStatus() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=fpStat`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchStatus = response.data.datas;
        // if(this.forms.cabang!='JAKARTA'){
        //     this.fetchStatus = ['WS-EXT'];
        // }else{
        //     this.fetchStatus = response.data.datas;
        // }
      });
    },

    loadMaintenancePlant() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=fpMplan`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchMaintenancePlant = response.data.datas;
      });
    },

    loadFeatchUnit() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=fpRout`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchRoute = response.data.datas;
      });
    },

    loadFeatchTypeService() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=fpTser`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchTypeService = response.data.datas;
        this.fetchTypeService2 = response.data.datas;
      });
    },

    customLabel(ev) {
      return `${ev.driver_id} – ${ev.driver_name}`;
    },

    getKm() {
      this.loadingMGps = true;
      this.km_gps = 0;
      var nopol = this.truck.vehicle_no;

      if (nopol == null || nopol == '' || nopol == undefined) {
        this.loadingMGps = false;
        this.error('Vehicle No is empty');
      } else {
        const baseURI = this.$settings.endPointCt + `master-truck/get-lastkm/` + nopol;
        return this.$http
          .get(baseURI)
          .then((response) => {
            if (response.data.status == 200) {
              if (response.data.datas?.messages == undefined) {
                this.loadingMGps = false;
                //console.log(response.data.datas.last_km);
                this.km_gps = response.data.datas.last_km;
                // return this.forms.km_gps;
              } else {
                this.loadingMGps = false;
                this.error(response.data.datas.messages);
              }
            }
          })
          .catch((error) => {
            this.loadingMGps = false;
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                if (this.errors.message) {
                  this.error(this.errors.message);
                } else {
                  this.resultError(error.response.data.errors);
                }
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                this.$router.push('/page-not-found');
              }
            }
            //this.resetForm();
          });
      }
    },

    changeServiceRemark(ev) {
      // console.log(ev)
      if (ev == 'Selesai Service') {
        this.service_remarks_ = true;
        this.fieldSelesaiService = true;
      } else {
        this.fieldSelesaiService = false;
        this.service_remarks_ = false;
      }
    },

    loadMerk() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=fpMplan`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchMerk = response.data.datas;
      });
    },

    loadTruck() {
      const baseURI = this.$settings.endPointCt + `master-truck?select=select`;

      return this.$http.get(baseURI).then((response) => {
        let data = {
          category: ' -- Select All Truck --',
          truck: response.data.datas.data,
        };

        this.fetchTruck.push(data);
      });
    },

    asyncSearchTruck(ev) {
      const baseURI = this.$settings.endPointCt + `master-truck?vehicle_no=` + ev;

      return this.$http.get(baseURI).then((response) => {
        response.data.datas.data.forEach((item) => {
          const data = {
            master_truck_id: item.master_truck_id,
            vehicle_no: item.vehicle_no,
          };
          this.fetchTruck.push(data);
        });
      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'PenerimaanFppkController') {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      this.permision_role = rolePermision;

      //console.log(this.permision_role.method_custom1);
    },

    backForm() {
      window.location.href = '/fppk-penerimaan';
    },

    fade(sType) {
      this.isLoading = sType;
    },

    submitToCt(row) {
      this.fade(true);
      const baseURI = this.$settings.endPointCt + 'master-truck/update-truck-status-for-fppk';
      this.$http
        .post(baseURI, row)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            // this.updateStatus(row.fppk_id, 'Pengajuan')
            //console.log(response.data.datas.user_id);
            // var params = this.$onRandom(row.fppk_id);
            // window.location.href =
            //     "/fppk-penerimaan/detail/" + params + "?status=200&msg=Successfully";
            // this.success('Berhasil');
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              if (this.errors.message) {
                this.error(this.errors.message);
              } else {
                this.resultError(error.response.data.errors);
              }
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push('/page-not-found');
            }
          }
          //this.resetForm();
        });
    },

    loadJenisUnit() {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=truca`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchJenisUnit = response.data.datas;
      });
    },

    asyncJenisUnit(ev) {
      const baseURI = this.$settings.endPointCt + `master-lookup?unique_id=truca&search=${ev}`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchJenisUnit = response.data.datas;
      });
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    preventEnterInTable() {
      this.$nextTick(() => {
        const tableInputs = this.$el.querySelectorAll('.vue-good-table input');
        tableInputs.forEach((input) => {
          input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') e.preventDefault();
          });
        });
      });
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer);
          toast.addEventListener('mouseleave', this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: 'success',
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer);
          toast.addEventListener('mouseleave', this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: 'error',
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadStatus();
    this.loadJenisUnit();
    this.loadFeatchUnit();
    this.loadTruck();
    this.loadDriver();
    this.loadMaintenancePlant();
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.loadDataDetailActivity(params[0]);
    this.loadFeatchTypeService();
    this.preventEnterInTable();
    this.loadSearchActivity();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
<style scoped>
::v-deep(th.line-numbers) {
  vertical-align: top !important;
}

::v-deep(.vgt-left-align) {
  vertical-align: top !important;
}

.vue-good-table .vgt-row td {
  vertical-align: top !important;
  padding-top: 8px;
}

.no-line-number-row td:first-child {
  visibility: hidden;
}

.dropdown-list {
  position: absolute;
  background: white;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  z-index: 100;
  margin-top: 2px;
  padding: 0;
  list-style: none;
  border-radius: 4px;
}

.dropdown-item {
  padding: 6px 10px;
  cursor: pointer;
}

.dropdown-item.active {
  background-color: #f0f0f0;
}

.dropdown-spinner {
  display: flex;
  justify-content: center;
  padding: 10px 0;
}

.spinner {
  border: 3px solid #eee;
  border-top: 3px solid #333;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.no-results {
  padding: 6px 10px;
  font-style: italic;
  color: #888;
}

.dropdown-list {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 2px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Styling untuk dropdown list */
.dropdown-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
}

.dropdown-item {
  padding: 10px;
  cursor: pointer;
}

/* Styling untuk item yang dipilih */
.dropdown-item.active {
  background-color: #3498db; /* Warna latar belakang saat item dipilih */
  color: white; /* Warna teks saat item dipilih */
}

/* Circular Progress Spinner */
.loading-indicator {
  padding: 10px;
  font-size: 14px;
  color: #888;
  text-align: center;
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid red; /* Ganti warna spinner menjadi merah */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Styling untuk pesan "Data tidak ditemukan" */
.no-results {
  color: red;
  padding: 5px;
  font-size: 14px;
  text-align: center;
}
</style>
